export enum LoginStatusEnum {
  SUCCESS,
  INVALID_CREDENTIALS,
  ERROR,
  NONE,
  BLOCKED,
  BLOCKED_WITH_REDIRECT,
  PASSWORD_RESET,
  WAITING,
  MFA_REQUIRED,
  MFA_SETUP_REQUIRED,
  INVALID_MFA_CODE,
  INVALID_RECOVERY_CODE,
}
